import React, { useState, useEffect, useRef, useCallback } from "react";
import CustomCardSlider from "../../Components/CardSlider/card-slider";
import "swiper/css";
import { useNavigate, useLocation } from "react-router-dom";
import { useToast } from "../../Utils/toastContext";
import { useSelector, useDispatch } from "react-redux";
import { debounce } from "lodash";
import DocumentPreview from "../Create-Investment/documentpreview";
import Dropdown from "../../Components/CustomDropdown/customdropdown";
import {
  setUserProfilePic,
  setUserProfilePicDownloadUrl,
} from "../../Redux/store/userSlice";
import DropdownTest from "../../Pages/Create-Investment/ndrop";
import countriesData from "../../Data/CountryCodes.json";
import CustomDropdownWithFetch from "../../Components/CustomDropdown/custom-dropdown-fetchAPI";
import PermissionSection from "../../Components/Permissions/permission-section";
import PermissionSectionDisabled from "../../Components/Permissions/permission-section-disabled";

const validator = require("validator");

const MyProfile = () => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const { showToast } = useToast();
  const cardCurrencyName = useSelector((state) => state.user.cardCurrencyName);
  const loggedInUserRole = useSelector((state) => state.user.roleName);
  const dispatch = useDispatch();
  const userId = useSelector((state) => state.user.userId);
  const navigate = useNavigate();
  const location = useLocation();
  const [filter, setFilter] = useState("profile");
  const [isOpenEdit, setisOpenEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [countryCodeData, setCountryCodeData] = useState([]);
  const [countryCodeProfile, setCountryCodeProfile] = useState("");
  const [customerType, setCustomerType] = useState("");
  const [newCity, setNewCity] = useState("");
  const [newState, setNewState] = useState("");
  const [newAddress, setNewAddress] = useState("");
  const [newZipCode, setNewZipCode] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [isModalOpenProfileEdit, setIsModalOpenProfileEdit] = useState(false);
  const [newLastName, setNewLastName] = useState("");
  const [newEmail, setNewEmail] = useState("");
  const [selectedCode, setSelectedCode] = useState("");
  const [newFirstName, setNewFirstName] = useState("");
  const [focus, setFocus] = useState(false);
  const [countries, setCountries] = useState([]);

  const handleCodeChange = (e) => {
    setSelectedCode(e.target.value);
  };
  const togglePopupEdit = () => {
    setisOpenEdit(!isOpenEdit);
    setcurrentPassword("");
    setnewPassword("");
    setconfirmPassword("");
    setShowConfirmPassword(false);
    setShowCurrentPassword(false);
    setShowNewPassword(false);
  };
  const [showconfirmPassword, setShowConfirmPassword] = useState(false);
  const [confirmPassword, setconfirmPassword] = useState("");
  const [showcurrentPassword, setShowCurrentPassword] = useState(false);
  const [currentpassword, setcurrentPassword] = useState("");
  const [shownewPassword, setShowNewPassword] = useState(false);
  const [newPassword, setnewPassword] = useState("");
  const [isNewChangeFees, setisNewChangeFees] = useState(true);
  const [profileData, setprofileData] = useState({});
  const [accountAnalytics, setAccountAnalytics] = useState({});
  const [addressData, setAddressData] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenProfile, setIsModalOpenProfile] = useState(false);
  const [countryCode, setCountryCode] = useState("AU");
  const [institutionNumber, setinstitutionNumber] = useState("");
  const [accountdata, setAccountData] = useState({
    no_of_active_accounts: 0,
    no_of_archieved_accounts: 0,
    active_accounts: {
      my_investments: 0,
    },
    archieved_accounts: {},
  });
  const [cardDatanew, setcardData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currentDocument, setcurrentDocument] = useState({});
  const [isOpenEditCashAccount, setisOpenEditCashAccount] = useState(false);
  const [addressLine1, setAddressLine1] = useState("");
  const [addressLine2, setAddressLine2] = useState("");
  const [addressLine3, setAddressLine3] = useState("");
  const [toCurrency, setToCurrency] = useState("");
  const [toAccountName, setToAccountName] = useState("");
  const [preselectedcashCurrency, setpreselectedCurrency] = useState({
    value: 2,
    label: "AUD",
  });
  const AllStatusExternal = [
    { label: "Approved", value: "approved" },
    { label: "Rejected", value: "rejected" },
  ];
  const [preselectedCountryCode, setpreselectedCountryCode] = useState({
    value: "AU",
    label: "Australia",
  });
  const dropdownRef = useRef();

  const [toAccountNumber, setToAccountNumber] = useState("");
  const [toBank, setToBank] = useState("");
  const [currencyData, setCurrencyData] = useState([]);
  const [iban, setIban] = useState("");
  const fileInputRef = useRef(null);
  const [stream, setStream] = useState(null);
  const videoRef = useRef(null);
  const [showCamera, setShowCamera] = useState(false);
  const [animateCamera, setAnimateCamera] = useState(false);
  const canvasRef = useRef(null);
  const [preview, setPreview] = useState("");
  const [uploadPic, setUploadPic] = useState("");
  const profilePicURL = useSelector((state) => state.user.userProfilePic);
  const profilePicDownloadUrl = useSelector(
    (state) => state.user.userProfilePicDownloadUrl
  );
  const [isOpenEditCashAccountBank, setIsOpenEditCashAccountBank] =
    useState(false);
  const [totalCountExternalBank, setTotalCountExternalBank] = useState(0);
  const [currentPageExternalBank, setCurrentPageExternalBank] = useState(1);
  const [totalPagesExternalBank, setTotalPagesExternalBank] = useState(0);
  const [externalbankTable, setExternalbankTable] = useState([]);
  const [showRecordsExternalBank, setShowRecordsExternalBank] = useState(10);
  const buttonRefs = useRef({});
  const StatusRef = useRef();
  const [preSelectedFilter, setpreSelectedFilter] = useState({
    value: 10,
    label: "10",
  });
  const [openDropdown, setOpenDropdown] = useState(null);
  const [isStatusOpen, setIsStatusOpen] = useState(false);
  const [preselectedCustomerType, setpreselectedCustomerType] = useState({
    value: "AU",
    label: "Australia",
  });

  const [preselectedCountryCodeProfile, setpreselectedCountryCodeProfile] =
    useState({
      value: "AU",
      label: "Australia",
    });
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [preselectedCity, setpreselectedCity] = useState({});
  const [preselectedState, setpreselectedState] = useState({});
  const [cityData, setCityData] = useState([]);
  const [stateData, setStateData] = useState([]);
  const [countryData, setCountryData] = useState([]);

  const europeanCountryCodes = new Set([
    "AL",
    "AD",
    "AM",
    "AT",
    "AZ",
    "BY",
    "BE",
    "BA",
    "BG",
    "HR",
    "CY",
    "CZ",
    "DK",
    "EE",
    "FI",
    "FR",
    "GE",
    "DE",
    "GR",
    "HU",
    "IS",
    "IE",
    "IT",
    "KZ",
    "LV",
    "LI",
    "LT",
    "LU",
    "MT",
    "MD",
    "MC",
    "ME",
    "NL",
    "MK",
    "NO",
    "PL",
    "PT",
    "RO",
    "RU",
    "SM",
    "RS",
    "SK",
    "SI",
    "ES",
    "SE",
    "CH",
    "TR",
    "UA",
    "GB",
    "VA",
  ]);
  const [permissions, setPermissions] = useState({});
  const [chunks, setChunks] = useState([]);

  // Toggle handler
  const handleToggle = (section, id) => {
    setPermissions((prev) => ({
      ...prev,
      [section]: prev[section].map((perm) =>
        perm.unique_id === id ? { ...perm, status: !perm.status } : perm
      ),
    }));
  };
  const buildPayload = () => {
    let payload = [];

    // Loop through each section (account, bank, etc.)
    Object.values(permissions).forEach((section) => {
      section.forEach((perm) => {
        payload.push({
          unique_id: perm.unique_id,
          allowed: perm.status, // status → allowed
          // valid_from: "2020-05-01",   // optional
          // valid_until: "2026-06-01"  // optional
        });
      });
    });

    return payload;
  };

  useEffect(() => {
    setCountries(countriesData);
  }, []);
  useEffect(() => {
    if (Object.keys(permissions).length > 0) {
      const sectionEntries = Object.entries(permissions);
      const chunkSize = 3;
      const newChunks = [];

      for (let i = 0; i < sectionEntries.length; i += chunkSize) {
        newChunks.push(sectionEntries.slice(i, i + chunkSize));
      }
      setChunks(newChunks);
    }
  }, [permissions]);

  const handleSelectCountryCodeProfile = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setCountryCodeProfile(selectedOption.value);
    setStateData([]);
    setCityData([]);
    setpreselectedCity({});
    setpreselectedState({});
  };
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
  const handleSelectCustomerType = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setCustomerType(selectedOption.value);
  };
  // Step 2: Function to check if a code is European
  function isEuropeanCountry(code) {
    return europeanCountryCodes.has(code.toUpperCase());
  }
  const toggleConfirmPassword = () => {
    setShowConfirmPassword((prevState) => !prevState);
  };
  const handleshowRecordBank = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setShowRecordsExternalBank(parseInt(selectedOption.value));
    setCurrentPageExternalBank(1);
  };
  const handleSelectCity = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setNewCity(selectedOption.value);
  };
  const handleSelectCountryCode = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setCountryCode(selectedOption.value);
  };
  const handleSelectState = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setNewState(selectedOption.value);
  };
  const editProfile = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/user/profile/update/${profileData.id}`;
    const bodyData = {
      first_name: newFirstName,
      last_name: newLastName,
      country_code: selectedCode,
      mobile_number: mobileNumber,
      email_address: newEmail,
      type: customerType,
      address: {
        city_id: newCity,
        country_id: countryCodeProfile,
        state_id: newState,
        zip_code: newZipCode,
        google_address: newAddress,
        address_line_1: "",
      },
    };
    try {
      const response = await fetch(apiUrl, {
        method: "PUT",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const updatePermission = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/permissions/user/update`;

    const bodyData = {
      user_id: userId,
      permissions: buildPayload(),
    };
    try {
      const response = await fetch(apiUrl, {
        method: "PUT",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const handleEditClickProfile = () => {
    setIsModalOpenProfileEdit(true);
    setNewFirstName(profileData.first_name);
    setNewLastName(profileData.last_name);
    setNewEmail(profileData.email_address);
    setMobileNumber(profileData.mobile_number);
    setSelectedCode(profileData.country_code);
    setpreselectedCountryCodeProfile({
      value: addressData.country.id,
      label: addressData.country.name,
    });
    setCountryCodeProfile(addressData.country.id);
    setpreselectedCity({
      value: addressData.city.id,
      label: addressData.city.name,
    });
    setNewCity(addressData.city.id);
    setpreselectedState({
      value: addressData.state.id,
      label: addressData.state.name,
    });
    setNewState(addressData.state.id);
    setNewZipCode(addressData.zip_code);
    setNewAddress(addressData.google_address);
  };
  const handleDropdownToggleExternalbank = (id) => {
    // Toggle dropdown for the specific row
    if (openDropdown === id) {
      setOpenDropdown(null); // Close if already open
    } else {
      setOpenDropdown(id); // Open the dropdown for the specific row
    }
  };
  const formatDateList = (dateString) => {
    const [datePart] = dateString.split(" "); // Extract the date portion
    const [day, month, year] = datePart.split("/"); // Split into day, month, and year
    return `${day}/${month}/${year}`;
  };
  const handleProfileClick = () => {
    setIsModalOpenProfile(true);
  };

  const handleSelectToCurrency = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setToCurrency(selectedOption.value);
  };
  const fileUploadNew = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {};

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl = `${BASE_URL}/v1/user/upload/profile-image`;
    const formData3 = new FormData();
    formData3.append("profile_image", uploadPic); // Append file
    try {
      const response = await fetch(apiUrl, {
        method: "POST",
        headers,
        body: formData3,
      });
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };
  const getAllBanksDataAdmin = async () => {
    try {
      setIsLoading(true);
      // Determine the base path based on role
      const basePath =
        loggedInUserRole === "advisor"
          ? `/v1/advisor/account/external-bank/list/external`
          : `/v1/account/external-bank/list/external`;

      // Build query params
      const params = new URLSearchParams({
        limit: showRecordsExternalBank,
        page: currentPageExternalBank,
      });

      // Add status param if selected
      if (selectedStatus) {
        params.append("status", selectedStatus);
      }
      const response = await GetAPIcalls(`${basePath}?${params.toString()}`);
      if (
        response.status == 200 &&
        response.data &&
        response.data.bank_accounts.length > 0
      ) {
        setExternalbankTable(response.data.bank_accounts);
        setTotalPagesExternalBank(response.data.total_pages);
        setCurrentPageExternalBank(response.data.page);
        setTotalCountExternalBank(response.data.total_count);
      } else {
        setExternalbankTable([]);
        setTotalPagesExternalBank(0);
        setCurrentPageExternalBank(1);
        setTotalCountExternalBank(0);
      }
    } catch (err) {
      setExternalbankTable([]);
      setTotalPagesExternalBank(0);
      setCurrentPageExternalBank(1);
      setTotalCountExternalBank(0);
      showToast(err.message, "error");
    } finally {
      setTimeout(function () {
        setIsLoading(false);
      }, 100);
    }
  };
  const handleUploadFile = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await fileUploadNew();
        if (response.status == 200) {
          handleCloseCamera();
          dispatch(setUserProfilePic(response.data.profile_image_url));
          dispatch(
            setUserProfilePicDownloadUrl(
              response.data.profile_image_url_download
            )
          );
        } else {
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [uploadPic] // Dependencies
  );

  const handleEditProfile = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await editProfile();
        if (response.status == 200) {
          setIsModalOpenProfileEdit(false);
          getprofileData();
          toastMessage = {
            message: "Details updated successfully.",
            type: "success",
          };
        } else {
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [
      newFirstName,
      newLastName,
      selectedCode,
      mobileNumber,
      newEmail,
      customerType,
      newCity,
      countryCodeProfile,
      newState,
      newZipCode,
      newAddress,
    ] // Dependencies
  );
  const handleUpdatePermissions = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await updatePermission();
        if (response.status == 200) {
          getAllUserPermissions();
          toastMessage = {
            message: "Details updated successfully.",
            type: "success",
          };
        } else {
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [userId, permissions] // Dependencies
  );
  const getAllCountryCode = async () => {
    try {
      const response = await GetAPIcalls(`/v1/user/country-codes`);

      if (response.status == 200) {
        let AllAccount = [];
        Object.entries(response.data).forEach(([key, value]) => {
          AllAccount.push({
            value: key,
            label: value,
          });
        });

        setCountryCodeData(AllAccount);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
      }
    } catch (err) {
      setCountryCodeData([]);
      setpreselectedCountryCode({});
      handleSelectCountryCode({});
      showToast(err.message, "error");
    } finally {
    }
  };
  const getAllCountries = async () => {
    try {
      const response = await GetAPIcalls(`/v1/user/countries?size=1000`);

      if (response.status == 200) {
        let AllAccount = [];
        response.data.countries.forEach((item) => {
          AllAccount.push({
            value: item.id,
            label: item.name,
          });
        });

        setCountryData(AllAccount);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
      }
    } catch (err) {
      setCountryData([]);
      setpreselectedCountryCode({});
      handleSelectCountryCode({});
      showToast(err.message, "error");
    } finally {
    }
  };
  const getCities = async (page, searchTerm) => {
    try {
      // Backend should support pagination & search
      const size = 20; // fetch 50 cities per page
      const response = await GetAPIcalls(
        `/v1/user/cities/${countryCodeProfile}?page=${page}&size=${size}&search=${
          searchTerm || ""
        }`
      );

      if (response.status === 200) {
        const items = response.data.cities.map((item) => ({
          value: item.id,
          label: item.name,
        }));

        return {
          items,
          hasMore: response.data.cities.length === size, // if less than size, no more data
        };
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        return { items: [], hasMore: false };
      }
    } catch (err) {
      showToast(err.message, "error");
      return { items: [], hasMore: false };
    }
  };
  const getStates = async (page, searchTerm) => {
    try {
      // Backend should support pagination & search
      const size = 20; // fetch 50 cities per page
      const response = await GetAPIcalls(
        `/v1/user/states/${countryCodeProfile}?page=${page}&size=${size}&search=${
          searchTerm || ""
        }`
      );

      if (response.status === 200) {
        const items = response.data.states.map((item) => ({
          value: item.id,
          label: item.name,
        }));

        return {
          items,
          hasMore: response.data.states.length === size, // if less than size, no more data
        };
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        return { items: [], hasMore: false };
      }
    } catch (err) {
      showToast(err.message, "error");
      return { items: [], hasMore: false };
    }
  };

  const getAllCurrency = async () => {
    try {
      const response = await GetAPIcalls(`/v1/account/currencies`);

      if (response.status == 200) {
        let AllAccount = [];
        response.data.currencies.forEach((profile) => {
          AllAccount.push({
            value: profile.id,
            label: profile.name,
          });
        });

        setCurrencyData(AllAccount);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
    }
  };
  const toggleCurrentPassword = () => {
    setShowCurrentPassword((prevState) => !prevState);
  };
  const toggleNewPassword = () => {
    setShowNewPassword((prevState) => !prevState);
  };

  const UpdateRequestStatusCallBank = async (optionValue, rowId) => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };
    const apiUrl =
      optionValue.value == "approved"
        ? `${BASE_URL}/v1/account/external-bank/approve/${rowId}`
        : `${BASE_URL}/v1/account/external-bank/reject/${rowId}`;
    const bodyData = {};
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    try {
      const response = await fetch(apiUrl, {
        method: "PUT",
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));

        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };

  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem("jwtToken");
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }
      return await response.json();
    } catch (error) {
      console.error("API Call Error:", error); // Log full error for debugging
      throw new Error(
        typeof error.message === "string"
          ? error.message
          : "Network error, please try again later"
      );
    }
  };
  const getprofileData = async () => {
    try {
      setIsLoading(true);
      const response = await GetAPIcalls(
        `/v1/user/profile/me?currency=${cardCurrencyName.label}`
      );

      if (response.status == 200) {
        setprofileData(response.data.my_profile);
        setAccountAnalytics(response.data.portfolio);
        setAddressData(response.data.address);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          setprofileData({});
        }
      }
    } catch (err) {
      showToast(err.message, "error");
      setprofileData({});
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 300);
    }
  };
  const getAllUserPermissions = async () => {
    try {
      setIsLoading(true);
      const response = await GetAPIcalls(
        loggedInUserRole == "advisor"
          ? `/v1/advisor/permissions/me?limit=100`
          : `/v1/permissions/user/${userId}`
      );

      if (response.status == 200) {
        setPermissions(response.data.permissions);
      } else {
        if (response.status === 400) {
          setPermissions([]);
        }
      }
    } catch (err) {
      showToast(err.message, "error");
      setPermissions([]);
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 300);
    }
  };

  const handleUploadClick = () => {
    fileInputRef.current.click();
  };

  const getAccountData = async () => {
    setAccountData({
      no_of_active_accounts: 0,
      no_of_archieved_accounts: 0,
      active_accounts: {
        my_investments: 0,
      },
      archieved_accounts: {},
    });
    try {
      setIsLoading(true);
      const response = await GetAPIcalls(
        `/v1/merchant/dashboard/profile/accounts`
      );

      if (response.status == 200) {
        setAccountData(response.data);
      } else {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
        }
        if (response.status === 400) {
          setAccountData({});
          showToast(response.message, "error");
        }
      }
    } catch (err) {
      showToast(err.message, "error");
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 300);
    }
  };

  useEffect(() => {
    if (filter === "profile") {
      getprofileData();
      getAllCountries();
    }
    if (filter === "permissions") {
      getAllUserPermissions();
    }
  }, [filter]);

  const UpdatePassword = async () => {
    const token = localStorage.getItem("jwtToken");
    const headers = {
      "Content-Type": "application/json",
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const apiUrl =
      loggedInUserRole == "advisor"
        ? `${BASE_URL}/v1/advisor/user/change-password`
        : `${BASE_URL}/v1/user/change-password`;
    const bodyData = {
      old_password: currentpassword,
      new_password: newPassword,
    };
    try {
      const response = await fetch(apiUrl, {
        method: "PUT",
        headers,
        body: JSON.stringify(bodyData),
      });
      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem("jwtToken");
          navigate("/login");
          throw new Error("Session expired. Please log in again.");
        }
        const errorData = await response.json().catch(() => ({
          message: "An unexpected error occurred",
        }));
        throw new Error(errorData.message || "Something went wrong");
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || "Network error, please try again later");
    }
  };
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const validTypes = ["image/png", "image/jpeg"];
    const maxSizeMB = 10;

    if (!validTypes.includes(file.type)) {
      showToast("Please upload an image in PNG or JPEG format.", "error");
      return;
    }

    if (file.size > maxSizeMB * 1024 * 1024) {
      showToast("File size must be less than 10MB.", "error");
      return;
    }
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setPreview(imageUrl);
      setUploadPic(file);
    }
  };
  const handleUpdatePassword = useCallback(
    debounce(async (e) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await UpdatePassword();

        if (response.status == 200) {
          togglePopupEdit();
          toastMessage = {
            message: "Password Updated successfully!",
            type: "success",
          };
        } else {
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
      } finally {
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [newPassword, currentpassword] // Dependencies
  );
  const formatDateTime = (dateTimeStr) => {
    const date = new Date(dateTimeStr);

    const pad = (num) => String(num).padStart(2, "0");

    const day = pad(date.getDate());
    const month = pad(date.getMonth() + 1); // Months are zero-based
    const year = date.getFullYear();

    const hours = pad(date.getHours());
    const minutes = pad(date.getMinutes());
    const seconds = pad(date.getSeconds());

    return `${day}/${month}/${year}`;
  };
  const startCamera = async () => {
    setPreview("");
    setUploadPic(null);
    setShowCamera(true);

    setTimeout(() => setAnimateCamera(true), 10); // trigger fade-in animation
    try {
      const newStream = await navigator.mediaDevices.getUserMedia({
        video: true,
      });
      setStream(newStream);
    } catch (err) {
      console.error("Camera access error:", err);
    }
  };
  const handleTakeSnap = () => {
    const video = videoRef.current;
    const canvas = canvasRef.current;
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    canvas.getContext("2d").drawImage(video, 0, 0);
    const dataUrl = canvas.toDataURL("image/png");
    setPreview(dataUrl);
    fetch(dataUrl)
      .then((res) => res.blob())
      .then((blob) => {
        const file = new File([blob], "photo.png", { type: "image/png" });
        setUploadPic(file); // now you can send this file to API
      });
    // cleanup
    //handleCloseCamera();
  };
  const handleCloseCamera = () => {
    setAnimateCamera(false); // start fade-out
    setTimeout(() => {
      if (stream) {
        stream.getTracks().forEach((track) => track.stop());
        setStream(null);
      }
      setShowCamera(false); // hide modal after animation
    }, 300); // match duration-300
  };
  const handleStatusChangeBank = useCallback(
    debounce(async (e, option, rowId) => {
      e.preventDefault();
      let toastMessage = null;
      try {
        const response = await UpdateRequestStatusCallBank(option, rowId);
        if (response.status == 200) {
          toastMessage = {
            message: "Request completed successfully",
            type: "success",
          };
          getAllBanksDataAdmin();
        } else {
          toastMessage = { message: response.message, type: "error" };
        }
      } catch (err) {
        toastMessage = { message: err.message, type: "error" };
      } finally {
        handleDropdownToggleExternalbank(null);
        setLoading(false); // Ensure `loading` is false first
        // Show toast after loading is false
        if (toastMessage) {
          setTimeout(() => {
            showToast(toastMessage.message, toastMessage.type);
          }, 300); // Small delay if needed
        }
      }
    }, 1000), // Debounce time
    [] // Dependencies
  );
  // assign stream to video after it's rendered
  useEffect(() => {
    if (videoRef.current && stream) {
      videoRef.current.srcObject = stream;
      videoRef.current.play();
    }
  }, [stream]);
  return (
    <div className="w-full">
      {loading && (
        <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
          <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
        </div>
      )}
      <div className="pt-4 text-xs overflow-x-auto  flex-wrap items-center">
        <div className="flex mb-2 ">
          <button
            onClick={() => setFilter("profile")}
            className={`px-4 py-2 lg:w-20 rounded-l-xl border-r border-gray-100 ${
              filter === "profile"
                ? "bg-black text-white"
                : "bg-white text-black"
            }`}
          >
            Profile
          </button>
          <button
            onClick={() => setFilter("permissions")}
            className={`px-4 py-2 rounded-r-xl ${
              filter === "permissions"
                ? "bg-black text-white"
                : "bg-white text-black"
            }`}
          >
            Permissions
          </button>
        </div>
      </div>
      {/* Summary Cards */}
      {isLoading ? (
        <div className="shimmer-container-list mb-4 ">
          {/* Creating 5 rows of shimmer effect */}
          {[...Array(2)].map((_, rowIndex) => (
            <div key={rowIndex} className="shimmer-row-list">
              {/* Creating 7 cells in each row for shimmer */}
              {[...Array(2)].map((_, colIndex) => (
                <div key={colIndex} className="shimmer-cell-list h-20">
                  <div className="shimmer-loader"></div>
                </div>
              ))}
            </div>
          ))}
        </div>
      ) : (
        <div>
          {/* {filter === "accounts" && (
            <CustomCardSlider
              componentName="customer-details"
              cardData={cardDatanew}
            />
          )} */}
        </div>
      )}

      {filter == "profile" && (
        <div className="lg:min-w-[78vw] lg:max-w-[80vw]">
          <div className="w-full p-4 bg-white rounded-lg shadow-lg">
            {/* Header Section */}
            <div className="flex w-full  flex-col md:flex-row justify-between items-start md:items-center border-b pb-5 border-gray-100">
              <div className="flex items-center mb-2 md:mb-0">
                <img
                  src="/profile-circle-black.svg"
                  alt="Company Logo"
                  className="mr-3 w-6 h-6"
                />
                <span className="font-medium lg:text-xl text-sm">Profile</span>
              </div>
              <p className="text-sm">
                <span className="font-medium text-labelLightColour">
                  Member since:{" "}
                </span>
                <span className="font-medium text-black">
                  {formatDateTime(profileData.created_at)}
                </span>
                <button
                  onClick={() => handleEditClickProfile()}
                  className="  right-4 px-3 rounded-md text-sm transition-colors duration-200"
                >
                  <img
                    src="/edit-details.svg" // Replace with the actual path to your edit icon
                    alt="Edit Icon"
                    className="w-4 h-4 cursor-pointer"
                  />
                </button>
              </p>
            </div>
            {isModalOpenProfileEdit && (
              <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                <div className="bg-white rounded-lg w-[90%] md:w-[900px] p-6 mt-4 h-[90vh] max-h-screen overflow-y-auto">
                  {/* Modal Header */}
                  <div>
                    <div className="flex items-center justify-between mb-4">
                      <h2 className="text-lg font-medium text-center w-full">
                        Edit Personal Details
                      </h2>
                      <div className="flex justify-end">
                        <img
                          onClick={() => {
                            setIsModalOpenProfileEdit(false);
                          }}
                          src="/add.svg"
                          alt="Add"
                          className="w-10 h-10 cursor-pointer"
                        />
                      </div>
                    </div>
                    <div className="grid px-4 grid-cols-1 md:grid-cols-2 gap-6">
                      {/* Left Column */}
                      <div className="space-y-4 pt-4 px-4">
                        {/* Code */}
                        <div>
                          <label
                            htmlFor="finInstituition"
                            className="mb-1 text-sm text-labelColour"
                          >
                            First Name
                          </label>{" "}
                          <input
                            id="finInstituition"
                            type="text"
                            value={newFirstName}
                            onChange={(e) => setNewFirstName(e.target.value)}
                            className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                            placeholder="John"
                          />
                        </div>
                        <div>
                          <label
                            htmlFor="finInstituition"
                            className="mb-1 text-sm text-labelColour"
                          >
                            Last Name
                          </label>{" "}
                          <input
                            id="finInstituition"
                            type="text"
                            value={newLastName}
                            onChange={(e) => setNewLastName(e.target.value)}
                            className="bg-white border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                            placeholder="Doe"
                          />
                        </div>
                      </div>

                      {/* Center Column with Border */}
                      <div className="space-y-4 lg:pt-4 pt-0  sm:border-l-0 border-r-0 md:border-l border-gray-300 px-4">
                        <div className="mb-4">
                          <label
                            htmlFor="mobileNumber"
                            className="mb-1 text-sm text-labelColour"
                          >
                            Mobile Number
                          </label>
                          <div className="flex  items-center">
                            <select
                              value={selectedCode}
                              onChange={handleCodeChange}
                              onFocus={() => setFocus(true)}
                              onBlur={() => setFocus(false)}
                              className={` text-code font-medium input-field-mobilecode rounded-md px-2  ${
                                focus
                                  ? "border-black border-2"
                                  : "border-gray-300 border"
                              } border-r-0 leading-tight focus:outline-none `}
                              placeholder="AU+61"
                            >
                              {countries.map((country) => (
                                <option
                                  key={country.code}
                                  value={country.dialCode}
                                >
                                  {country.code} {country.dialCode}
                                </option>
                              ))}
                            </select>
                            <input
                              type="tel"
                              id="mobileNumber"
                              value={mobileNumber}
                              onFocus={() => setFocus(true)}
                              onBlur={() => setFocus(false)}
                              onChange={(e) => setMobileNumber(e.target.value)}
                              placeholder="Mobile Number"
                              className={`border  text-black text-base font-medium input-field-mobile px-2 ${
                                focus
                                  ? "border-black border-2"
                                  : "border-gray-300 border"
                              } rounded-md focus:outline-none w-full border-l-0 appearance-none`}
                            />
                          </div>
                        </div>
                        <div>
                          <label
                            htmlFor="finInstituition"
                            className="mb-1 text-sm text-labelColour"
                          >
                            Email
                          </label>{" "}
                          <input
                            id="finInstituition"
                            type="text"
                            value={newEmail}
                            onChange={(e) => setNewEmail(e.target.value)}
                            className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                            placeholder="Your Email"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="mt-2 flex items-center  border-b border-colour-custom space-x-2  pt-2 px-4">
                      <h1 className="text-md font-medium mb-2 text-center">
                        Location Details
                      </h1>
                    </div>{" "}
                    <div className="grid px-4 grid-cols-1 md:grid-cols-3 gap-6">
                      {/* Left Column */}
                      <div className="space-y-4 pt-4 px-4">
                        <div className="">
                          <Dropdown
                            label="Select Country"
                            options={countryData}
                            search={true}
                            preselectedValue={preselectedCountryCodeProfile}
                            onSelect={handleSelectCountryCodeProfile}
                            colorLabel=""
                          />
                        </div>
                        <div>
                          <CustomDropdownWithFetch
                            label="Select City"
                            options={cityData}
                            search={true}
                            preselectedValue={preselectedCity}
                            onSelect={handleSelectCity}
                            colorLabel=""
                            fetchOptions={getCities} // <-- pass fetch function, not options
                          />
                          {/* <input
                            id="finInstituition"
                            type="text"
                            value={newCity}
                            onChange={(e) => setNewCity(e.target.value)}
                            className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                            placeholder="Sydney..."
                          /> */}
                        </div>
                      </div>

                      {/* Center Column with Border */}
                      <div className="space-y-4 lg:pt-4 pt-0  sm:border-l-0 sm:border-r-0 md:border-l md:border-r border-gray-300 px-4">
                        <div>
                          <CustomDropdownWithFetch
                            label="Select State"
                            options={stateData}
                            search={true}
                            preselectedValue={preselectedState}
                            onSelect={handleSelectState}
                            colorLabel=""
                            fetchOptions={getStates} // <-- pass fetch function, not options
                          />
                          {/* <label
                            htmlFor="finInstituition"
                            className="mb-1 text-sm text-labelColour"
                          >
                            State
                          </label>{" "}
                          <input
                            id="finInstituition"
                            type="text"
                            value={newState}
                            onChange={(e) => setNewState(e.target.value)}
                            className="bg-white border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                            placeholder="NSW"
                          /> */}
                        </div>
                        <div>
                          <label
                            htmlFor="finInstituition"
                            className="mb-1 text-sm text-labelColour"
                          >
                            Zip Code
                          </label>{" "}
                          <input
                            id="finInstituition"
                            type="text"
                            value={newZipCode}
                            onChange={(e) => setNewZipCode(e.target.value)}
                            className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                            placeholder="Apartment unit 2 etc..."
                          />
                        </div>
                      </div>

                      {/* Right Column */}
                      <div className="space-y-4 px-4 pt-4">
                        <div>
                          <label
                            htmlFor="finInstituition"
                            className="mb-1 text-sm text-labelColour"
                          >
                            Address
                          </label>{" "}
                          <textarea
                            id="finInstituition"
                            type="text"
                            value={newAddress}
                            onChange={(e) => setNewAddress(e.target.value)}
                            className="bg-white  border border-gray-300 block w-full p-2 text-black font-medium rounded-md text-md"
                            placeholder="Apartment unit 2 etc..."
                          />
                          {/* <AddressAutocomplete onSelect={(addr) => setSelectedAddress(addr)} />

      {selectedAddress && (
        <div className="mt-4 p-4 border rounded">
          <p><strong>Full:</strong> {selectedAddress.full}</p>
          <p><strong>Street:</strong> {selectedAddress.street}</p>
          <p><strong>City:</strong> {selectedAddress.city}</p>
          <p><strong>State:</strong> {selectedAddress.state}</p>
          <p><strong>ZIP:</strong> {selectedAddress.zip}</p>
          <p><strong>Country:</strong> {selectedAddress.country}</p>
        </div>
      )} */}
                        </div>
                      </div>
                    </div>
                    <div className="flex justify-center space-x-4 mt-6 md:mt-20">
                      <button
                        onClick={() => {
                          setIsModalOpenProfileEdit(false);
                        }}
                        className="px-6 py-2 rounded-lg bg-gray-200 text-black hover:bg-gray-300"
                      >
                        Cancel
                      </button>
                      <button
                        onClick={(e) => {
                          e.preventDefault();
                          if (!validateEmail(newEmail)) {
                            showToast("Enter the valid email", "error");
                            return;
                          }
                          if (
                            !validator.isMobilePhone(
                              selectedCode + mobileNumber,
                              "any"
                            )
                          ) {
                            console.log("country code " + selectedCode);
                            console.log("mobile number is " + mobileNumber);
                            console.log(
                              validator.isMobilePhone(
                                selectedCode + mobileNumber,
                                "any"
                              )
                            );
                            showToast(
                              "Please enter valid mobile number",
                              "error"
                            );
                            return;
                          }
                          if (
                            !newFirstName ||
                            !newLastName ||
                            !newEmail ||
                            !selectedCode ||
                            !mobileNumber ||
                            !newCity ||
                            !newState ||
                            !newZipCode ||
                            !newAddress ||
                            !countryCodeProfile
                          ) {
                            showToast("Please Add all fields", "error");
                            return;
                          }
                          setLoading(true);
                          handleEditProfile(e);
                        }}
                        className="px-6 py-2 rounded-lg bg-black text-white hover:bg-gray-800"
                      >
                        Update Now
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {/* Profile Section */}
            <div className="flex w-full flex-col lg:flex-row items-start lg:items-center lg:space-x-6 ">
              {/* Profile Picture */}
              <div className="relative flex flex-col sm:flex-row items-center gap-4 mb-4 lg:mb-0">
                {/* Profile Picture */}
                <div className="relative">
                  <img
                    src={profilePicURL}
                    alt={`${profileData.first_name}`}
                    className="w-14 h-14 rounded-full object-cover"
                  />
                  {profileData.status === "active" && (
                    <div className="absolute top-2 left-12 w-3 h-3 bg-[#75E380] rounded-full"></div>
                  )}
                  {profileData.status === "rejected" && (
                    <div className="absolute top-2 left-12 w-3 h-3 bg-[#FF5050] rounded-full"></div>
                  )}
                  <label
                    htmlFor="investmentManagerFees"
                    className="mt-2 text-xs block text-center"
                  >
                    <span className="text-[#A6A6A6]">Client No:</span>
                  </label>
                  <p className="text-black text-sm text-center">
                    {profileData.client_id}
                  </p>
                </div>

                {/* Buttons */}
                <div className="flex flex-col space-y-2 mb-4">
                  <input
                    type="file"
                    accept="image/*"
                    className="hidden"
                    ref={fileInputRef}
                    onChange={handleFileChange}
                  />
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      handleProfileClick();
                    }}
                    className="bg-white text-black border-black border-2 text-xs px-3 py-1 rounded-full whitespace-nowrap"
                  >
                    View Picture
                  </button>
                  <button
                    onClick={startCamera}
                    className="bg-black text-white text-xs px-3 py-1 rounded-full flex items-center justify-center gap-2 whitespace-nowrap"
                  >
                    <img
                      src="/camera-black.svg"
                      alt="Camera Icon"
                      className="w-4 h-4"
                    />
                    Edit Picture
                  </button>
                </div>
              </div>

              {/* Profile Details */}
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 w-full ">
                {/* Column 1 */}
                <div className="flex flex-col md:px-4 md:pt-6 md:border-l">
                  <label
                    htmlFor="refId"
                    className="mb-1 text-xs text-[#A6A6A6]"
                  >
                    Status
                  </label>
                  <span className="text-sm">{profileData.status}</span>
                  {profileData.type !== "Corporate" && (
                    <>
                      <div className="mt-4">
                        <label
                          htmlFor="investmentType"
                          className="mb-1 text-xs text-[#A6A6A6]"
                        >
                          First Name
                        </label>
                        <div className="text-sm">{profileData.first_name}</div>
                      </div>
                      <div className="mt-4">
                        <label
                          htmlFor="investmentType"
                          className="mb-1 text-xs text-[#A6A6A6]"
                        >
                          Last Name
                        </label>
                        <div className="text-sm">{profileData.last_name}</div>
                      </div>
                    </>
                  )}

                  {profileData.type === "Corporate" && (
                    <>
                      <div className="mt-4">
                        <label
                          htmlFor="investmentType"
                          className="mb-1 text-xs text-[#A6A6A6]"
                        >
                          Company Name
                        </label>
                        <div className="text-sm">
                          {profileData.first_name} {profileData.last_name}
                        </div>
                      </div>
                    </>
                  )}
                </div>

                {/* Column 2 */}
                <div className="flex flex-col md:px-4 md:pt-6 md:border-l">
                  <label
                    htmlFor="investmentManagerFees"
                    className="mb-1 text-xs"
                  >
                    <span className="text-[#A6A6A6]">Phone</span>
                  </label>
                  <div className="text-sm">
                    {profileData.country_code}
                    {profileData.mobile_number}
                  </div>
                  {profileData.type !== "Corporate" && (
                    <>
                      <label
                        htmlFor="investmentManagerFees"
                        className="mb-1 mt-4 text-xs text-[#A6A6A6]"
                      >
                        Email
                      </label>
                      <span className="text-sm">
                        {profileData.email_address}
                      </span>
                    </>
                  )}
                  <label
                    htmlFor="investmentManagerFees"
                    className="mb-1 mt-4 text-xs text-[#A6A6A6]"
                  >
                    Type
                  </label>
                  <div className="text-sm">{profileData.type}</div>
                </div>

                {/* Column 3 */}
                {profileData.type !== "Corporate" && (
                  <div className="flex flex-col md:px-4 md:pt-6 md:border-l">
                    <label
                      htmlFor="investmentManagerFees"
                      className="mb-1 text-xs"
                    >
                      <span className="text-[#A6A6A6]">Password</span>
                    </label>
                    <div className="text-sm">{profileData.password}</div>
                    <button
                      onClick={togglePopupEdit}
                      className="mt-4 py-3 w-40 bg-black text-white text-sm rounded-md hover:bg-gray-800"
                    >
                      Change Password
                    </button>
                  </div>
                )}
                {isOpenEdit && (
                  <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <div className="bg-white rounded-lg w-[90%] md:w-[700px] p-6">
                      {/* Modal Header */}
                      <div className="flex items-center justify-between mb-4">
                        <h2 className="text-lg font-medium text-center w-full">
                          Change Password
                        </h2>
                        <button onClick={togglePopupEdit}>
                          <img
                            src="/add.svg"
                            alt="Close"
                            className="w-10 h-10"
                          />
                        </button>
                      </div>

                      {/* Modal Body */}
                      <div className="grid grid-cols-1 gap-6 items-center">
                        <div className="space-y-4 mx-auto ">
                          <div className="mb-4 relative">
                            <label
                              htmlFor="password"
                              className="block text-labelColour dark:text-gray-300 font-normal text-sm mb-1"
                            >
                              Current password
                            </label>
                            <input
                              type={showcurrentPassword ? "text" : "password"}
                              value={currentpassword}
                              required={true}
                              id="currentpassword"
                              onChange={(e) =>
                                setcurrentPassword(e.target.value)
                              }
                              className="dark:bg-[#101010] dark:border-[#4F4F4F] input-field appearance-none border w-full py-2 px-3  dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium leading-tight focus:outline-none focus:shadow-outline"
                              placeholder="Re-Type password"
                            />
                            <button
                              type="button"
                              onClick={toggleCurrentPassword}
                              className="absolute right-3 set-top"
                            >
                              {" "}
                              {showcurrentPassword ? (
                                <img
                                  src="/eye.svg"
                                  alt="Logo"
                                  className="h-auto"
                                />
                              ) : (
                                <img
                                  src="/eye-slash.svg"
                                  alt="Logo"
                                  className="h-auto"
                                />
                              )}
                            </button>
                          </div>
                          <div className="mb-4 relative">
                            <label
                              htmlFor="password"
                              className="block text-labelColour dark:text-gray-300 font-normal text-sm mb-1"
                            >
                              New password
                            </label>
                            <input
                              type={shownewPassword ? "text" : "password"}
                              value={newPassword}
                              required={true}
                              id="newpassword"
                              onChange={(e) => setnewPassword(e.target.value)}
                              className="dark:bg-[#101010] dark:border-[#4F4F4F] input-field appearance-none border w-full py-2 px-3  dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium leading-tight focus:outline-none focus:shadow-outline"
                              placeholder="Re-Type password"
                            />
                            <button
                              type="button"
                              onClick={toggleNewPassword}
                              className="absolute right-3 set-top"
                            >
                              {" "}
                              {shownewPassword ? (
                                <img
                                  src="/eye.svg"
                                  alt="Logo"
                                  className="h-auto"
                                />
                              ) : (
                                <img
                                  src="/eye-slash.svg"
                                  alt="Logo"
                                  className="h-auto"
                                />
                              )}
                            </button>
                          </div>
                          <div className="mb-4 relative">
                            <label
                              htmlFor="password"
                              className="block color-test dark:text-gray-300 font-normal color-test text-md mb-1"
                            >
                              Repeat password
                            </label>
                            <input
                              type={showconfirmPassword ? "text" : "password"}
                              value={confirmPassword}
                              required={true}
                              id="confirmpassword"
                              onChange={(e) =>
                                setconfirmPassword(e.target.value)
                              }
                              className="dark:bg-[#101010] dark:border-[#4F4F4F] input-field appearance-none border w-full py-2 px-3  dark:focus-visible:ring-[#4E4E4E] dark:text-white focus-visible:ring-1 focus-visible:ring-black text-black text-base font-medium leading-tight focus:outline-none focus:shadow-outline"
                              placeholder="Re-Type password"
                            />
                            <button
                              type="button"
                              onClick={toggleConfirmPassword}
                              className="absolute right-3 set-top"
                            >
                              {" "}
                              {showconfirmPassword ? (
                                <img
                                  src="/eye.svg"
                                  alt="Logo"
                                  className="h-auto"
                                />
                              ) : (
                                <img
                                  src="/eye-slash.svg"
                                  alt="Logo"
                                  className="h-auto"
                                />
                              )}
                            </button>
                          </div>
                        </div>
                      </div>

                      {/* Modal Footer */}
                      <div className="flex justify-center space-x-4 mt-6">
                        <button
                          onClick={togglePopupEdit}
                          className="px-6 py-2 rounded-lg bg-gray-200 text-black hover:bg-gray-300"
                        >
                          Cancel
                        </button>
                        <button
                          onClick={(e) => {
                            e.preventDefault();
                            if (newPassword.length < 8) {
                              showToast(
                                "Password must have At least 8 characters",
                                "error"
                              );
                              return;
                            }
                            if (!/(?=.*[0-9])/.test(newPassword)) {
                              showToast(
                                "Password must have At least 1 number",
                                "error"
                              );

                              return;
                            }
                            if (
                              !/(?=.*[!@#$%^&*()_+={}\[\]|:;"'<>,.?/`~\\/-])/.test(
                                newPassword
                              )
                            ) {
                              showToast(
                                "Password must have At least 1 special character",
                                "error"
                              );

                              return;
                            }
                            if (
                              !(
                                /(?=.*[a-z])/.test(newPassword) &&
                                /(?=.*[A-Z])/.test(newPassword)
                              )
                            ) {
                              showToast(
                                "Password must have Both upper and lower case characters",
                                "error"
                              );

                              return;
                            }
                            if (newPassword !== confirmPassword) {
                              showToast(
                                "Confirm password should be same as password",
                                "error"
                              );

                              return;
                            }
                            if (newPassword === currentpassword) {
                              showToast(
                                "New password should be different from current password",
                                "error"
                              );
                              return;
                            }
                            setLoading(true);
                            handleUpdatePassword(e);
                          }}
                          className="px-6 py-2 rounded-lg bg-black text-white hover:bg-gray-800"
                        >
                          Save
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          {showCamera && (
            <div
              className={`fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center p-4 transition-opacity duration-300 ease-in-out ${
                animateCamera ? "opacity-100" : "opacity-0"
              }`}
            >
              <div
                className={`relative transform transition-transform duration-300 ease-in-out bg-white rounded-xl p-4 w-full max-w-md flex flex-col items-center ${
                  animateCamera ? "scale-100" : "scale-90"
                }`}
              >
                {/* Preview or Live Camera */}
                {preview === "" ? (
                  <video
                    ref={videoRef}
                    autoPlay
                    playsInline
                    className="w-full h-auto rounded shadow-lg"
                  />
                ) : (
                  <div className="relative w-full">
                    <img
                      src={preview}
                      alt="Avatar"
                      className="w-full h-auto rounded shadow-lg"
                    />
                    <button
                      onClick={() => {
                        startCamera();
                      }}
                      className="absolute top-2 right-2 bg-white hover:bg-gray-100 p-1 rounded-full shadow-md transition"
                      aria-label="Remove preview"
                    >
                      <img src="/trash.svg" alt="Delete" className="w-4 h-4" />
                    </button>
                  </div>
                )}

                {/* Action Buttons */}
                <div className="flex flex-wrap justify-center gap-4 mt-4">
                  <button
                    onClick={handleCloseCamera}
                    className="bg-white text-black border-black border-2 text-sm px-4 py-2 rounded-full"
                  >
                    Cancel
                  </button>
                  {preview === "" && (
                    <>
                      <button
                        onClick={handleTakeSnap}
                        className="bg-black text-white text-sm px-4 py-2 rounded-full"
                      >
                        Capture Photo
                      </button>
                      <button
                        onClick={handleUploadClick}
                        className="bg-black text-white text-sm px-4 py-2 rounded-full"
                      >
                        Upload From Device
                      </button>
                      <input
                        type="file"
                        accept="image/*"
                        className="hidden"
                        ref={fileInputRef}
                        onChange={handleFileChange}
                      />
                    </>
                  )}
                  {preview !== "" && (
                    <>
                      <button
                        onClick={(e) => {
                          e.preventDefault();
                          setLoading(true);
                          handleUploadFile(e);
                        }}
                        className="bg-black text-white text-sm px-4 py-2 rounded-full"
                      >
                        Upload Photo
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>
          )}
          <canvas ref={canvasRef} className="hidden" />
          {isModalOpenProfile && profilePicURL && (
            <DocumentPreview
              fileUrl={profilePicDownloadUrl}
              fileName={profilePicURL.split("/").pop().split("?")[0]}
              onClose={() => setIsModalOpenProfile(false)}
            />
          )}
          <div className="pt-4  lg:flex lg:space-x-4 gap-4">
            {/* Left Section: Two Cards */}
            <div className="flex flex-col flex-[1.5] space-y-4">
              {/* Total Deposit Card */}
              <div className="bg-white p-6 rounded-lg shadow-lg w-full flex-1">
                <div className="flex justify-between border-b  items-start">
                  <div className="flex items-center pb-2 space-x-4">
                    <img
                      src="/folder-2.svg"
                      alt="Account Icon"
                      className="w-5 h-5"
                    />
                    <h3 className="text-black text-lg font-medium">
                      Accounts Analytics
                    </h3>
                  </div>
                </div>
                {accountAnalytics && (
                  <div className="flex flex-col sm:flex-row items-start sm:items-start justify-between gap-0 sm:gap-6">
                    <div className="text-sm text-gray-500 flex-1  sm:border-b-0 md:border-r sm:border-r-0 border-gray-300 pr-4 pt-4">
                      <div className="mb-4">
                        <p className="text-xs text-[#A6A6A6] mb-1">Portfolio</p>
                        <div className="font-medium text-black">
                          {cardCurrencyName.symbol}
                          {accountAnalytics?.total_portfolio
                            ? accountAnalytics.total_portfolio
                                .toFixed(2)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            : "0.00"}
                        </div>
                      </div>
                      <div className="mb-4">
                        <p className="text-xs text-[#A6A6A6] mb-1">Accounts</p>
                        <div className="font-medium text-black">
                          {accountAnalytics.no_of_cash_accounts}
                        </div>
                      </div>
                      <div>
                        <p className="text-xs text-[#A6A6A6] mb-1">Deposit</p>
                        <div className="font-medium text-black">
                          {cardCurrencyName.symbol}
                          {accountAnalytics?.total_deposit
                            ? accountAnalytics.total_deposit
                                .toFixed(2)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            : "0.00"}
                        </div>
                      </div>
                    </div>

                    {/* Withdrawal Section */}
                    <div className="text-sm text-gray-500 flex-1 pr-4 pt-4 flex sm:items-start">
                      <div className="self-start">
                        <p className="text-xs text-[#A6A6A6] mb-1">
                          Withdrawal
                        </p>
                        <div className="font-medium text-black">
                          {cardCurrencyName.symbol}
                          {accountAnalytics?.total_withdrawal
                            ? accountAnalytics.total_withdrawal
                                .toFixed(2)
                                .toString()
                                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                            : "0.00"}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* Right Section: Account Balance */}
            <div className="bg-white p-6 rounded-lg shadow-lg w-full lg:flex-[1.5] lg:mt-0 mt-4  border border-gray-200 flex-1">
              <div className="flex justify-between border-b  items-start">
                <div className="flex items-center pb-2 space-x-4">
                  <img
                    src="/map.svg"
                    alt="Account Icon"
                    className="w-5 h-5 rounded-full"
                  />
                  <h3 className="text-black text-lg font-medium">Location</h3>
                </div>
              </div>
              {addressData != null && (
                <div className="flex flex-col sm:flex-row items-start sm:items-start justify-between gap-0 sm:gap-6">
                  <div className="text-sm text-gray-500 flex-1  sm:border-b-0 md:border-r sm:border-r-0 border-gray-300 pr-4 pt-4">
                    <div className="mb-4">
                      <p className="text-xs text-[#A6A6A6] mb-1">Country</p>
                      <div className="font-medium text-black">
                        {addressData.country != null
                          ? addressData.country.name
                          : ""}{" "}
                      </div>
                    </div>
                    <div className="mb-4">
                      <p className="text-xs text-[#A6A6A6] mb-1">Zip Code</p>
                      <div className="font-medium text-black">
                        {addressData.zip_code}
                      </div>
                    </div>
                    <div>
                      <p className="text-xs text-[#A6A6A6] mb-1">State</p>
                      <div className="font-medium text-black">
                        {addressData.state != null
                          ? addressData.state.name
                          : ""}{" "}
                      </div>
                    </div>
                  </div>

                  {/* Withdrawal Section */}
                  <div className="text-sm text-gray-500 flex-1 pr-4 pt-4">
                    <div className="mb-4">
                      <p className="text-xs text-[#A6A6A6]">Address</p>
                      <div className="font-medium text-black">
                        {addressData.google_address}
                      </div>
                    </div>
                    <div className="mb-4">
                      <p className="text-xs text-[#A6A6A6]">City</p>
                      <div className="font-medium text-black">
                        {addressData.city != null ? addressData.city.name : ""}
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
      {filter == "permissions" && (
        <div className="lg:min-w-[78vw] lg:max-w-[80vw]">
          <div className="w-full p-4 bg-white rounded-lg shadow-lg">
            {/* Header */}
            <div className="flex w-full flex-col md:flex-row justify-between items-start md:items-center border-b pb-5 border-gray-200">
              <div className="flex items-center mb-2 md:mb-0">
                {/* Shield Icon */}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="black"
                  viewBox="0 0 24 24"
                  width="24"
                  height="24"
                >
                  <path d="M12 1l9 4v6c0 5-3.8 9.7-9 11-5.2-1.3-9-6-9-11V5l9-4zm-1 14.6l5.3-5.3-1.4-1.4L11 12.8l-1.9-1.9-1.4 1.4 3.3 3.3z" />
                </svg>
                <span className="font-semibold lg:text-xl text-base ml-2">
                  Permissions
                </span>
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 w-full ">
              {chunks.map((chunk, idx) => (
                <div
                  key={idx}
                  className="flex flex-col md:pl-4 md:pt-2 md:border-l"
                >
                  {chunk.map(([sectionName, sectionPerms]) => (
                    <>
                      {loggedInUserRole == "super_admin" && (
                        <PermissionSection
                          key={sectionName}
                          title={
                            sectionName.charAt(0).toUpperCase() +
                            sectionName.slice(1).replace("_", " ")
                          }
                          permissions={sectionPerms}
                          onToggle={handleToggle}
                        />
                      )}
                      {loggedInUserRole != "super_admin" && (
                        <PermissionSectionDisabled
                          key={sectionName}
                          title={
                            sectionName.charAt(0).toUpperCase() +
                            sectionName.slice(1).replace("_", " ")
                          }
                          permissions={sectionPerms}
                          onToggle={handleToggle}
                        />
                      )}
                    </>
                  ))}
                </div>
              ))}
            </div>
          </div>
          {loggedInUserRole == "super_admin" && (
            <div className="flex items-center mt-6 p-4 bg-[#005A9C]">
              {/* Right Section: Download Button */}
              <div className="flex flex-col md:flex-row items-center justify-end w-full mr-10 space-y-2 md:space-y-0 md:space-x-4">
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    getAllUserPermissions();
                  }}
                  className="flex w-full md:w-auto items-center space-x-2 bg-white text-black font-medium py-2 px-4 rounded-full text-sm hover:bg-gray-200"
                >
                  <span>Undo Changes</span>
                </button>
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    setLoading(true);
                    handleUpdatePermissions(e);
                  }}
                  className="flex w-full md:w-auto items-center space-x-2 bg-white text-black font-medium py-2 px-4 rounded-full text-sm hover:bg-gray-200"
                >
                  <span>Save Changes</span>
                </button>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default MyProfile;
